import React, { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LanguageContext } from "../contexts/LanguageContext";
import { useClientConfig } from "../contexts/ClientConfigContext";
import { CountryContext } from "../contexts/CountryContext";
import { DrawerContext } from "../contexts/DrawerContext";
import { translations } from "../lang/texts";
import { Menu } from "./Menu";
import { BurgerMenu, ChevronLeft, ThreeDots } from "./micro/icons";

//const imgRulesDefault = new URL("../../img/KIS_Global_(MASTER)_Logo_(CMYK)-min.png", import.meta.url);

const CountryFlagButton = () => {
  const { country } = useContext(CountryContext);
  const { drawerOpen, setDrawerOpen } = useContext(DrawerContext);
  const navigate = useNavigate();
  const location = useLocation();
  const flagCode = country === "uk" ? "gb" : country;

  const handleClick = () => {
    if (location.pathname.startsWith("/hints")) {
      // During hints, use the route instead of the drawer (avoids z-index conflict with Joyride)
      navigate("/countries");
    } else {
      setDrawerOpen(!drawerOpen);
    }
  };

  // Hide when already on countries/country-options pages
  if (location.pathname.startsWith("/countries") || location.pathname.startsWith("/country-options")) {
    return null;
  }

  return (
    <button onClick={handleClick} className="w-8 h-8 flex items-center justify-center">
      {flagCode ? (
        <span className={`fi fi-${flagCode} text-2xl`}></span>
      ) : (
        <span className="text-primary text-sm font-bold">🌍</span>
      )}
    </button>
  );
};

export const Navbar = () => {
  const language = useContext(LanguageContext);
  const clientConfig = useClientConfig();
  const navigate = useNavigate();
  const location = useLocation();
  const [isBackVisible, setIsBackVisible] = React.useState(false);
  const [isShown, setIsShown] = React.useState(false);

  // Use client logo if available, otherwise fall back to default
  const logoSrc = clientConfig.config_logo_url || "";

  useEffect(() => {
    console.log("location: ", location);
    location.pathname === "/landing" ? setIsBackVisible(false) : setIsBackVisible(true);
    location.pathname === "/result" ? setIsBackVisible(false) : setIsBackVisible(true);
  }, [location.pathname]);

  const onMenuClick = () => {
    console.log("menu click");
    setIsShown(!isShown);
  };
  return (
    <>
      <div className="bg-white flex justify-between h-24 items-center fixed top-0 left-0 w-full z-[1010] navbar">
        <span onClick={() => navigate(-1)} className={"text-primary back-arrow mx-5 " + (isBackVisible ? "" : " invisible")}>
          <ChevronLeft stroke={3.5} />
        </span>
        <div className="flex flex-col justify-center items-center">

          <img src={logoSrc} className="kiss-logo" alt={clientConfig.config_name || "Logo"} />

          {/*<h1 className="text-3xl font-bold text-primary">*/}
          {/*  <span className="text-primary">Self</span>*/}
          {/*  <span className="text-grayish">ID</span>*/}
          {/*  <span className="text-primary">eed</span>*/}
          {/*</h1>*/}
          {/*<h2 className="text-grayish font-bold text-s text-center">{language.common_subtitle}</h2>*/}
        </div>
        <span className="mx-5">
          <CountryFlagButton />
        </span>
        {/*<span onClick={onMenuClick} className="mx-5 text-primary">*/}
        {/*  <BurgerMenu stroke={2.5} extraClasses="w-8 h-8" />*/}
        {/*</span>*/}
      </div>
      {/* background shadow */}
      <div onClick={() => setIsShown(!isShown)} className={"transition-all ease-in-out fixed top-0 left-0 w-full h-screen z-[70] " + (isShown ? "bg-black bg-opacity-50" : "hidden")}></div>
      <Menu isShown={isShown} setIsShown={setIsShown} />
      {/*<Title />*/}
    </>
  );
};
